import React from 'react'
import Topbar from '../Components/Topbar'
import Navbar from '../Components/Navbar'
import { CartProvider } from 'react-use-cart'


function AllPages() {
  return (
    <CartProvider>
        <Topbar/>
        <Navbar/>
    </CartProvider>
  )
}

export default AllPages